import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-8">
      <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-slate-500 text-sm">
          &copy; {new Date().getFullYear()}{' '}
          <span className="text-slate-300 font-semibold">Muhammad Ilyas</span>. All rights reserved.
        </p>
        <p className="font-mono text-xs text-slate-600">
          Built with React &amp; TailwindCSS
        </p>
      </div>
    </footer>
  );
}
